<template>
  <v-container>
    <v-card outlined>
      <v-card-title>
        {{ $t('incoming_data') }}
      </v-card-title>
      <v-card-text>
        <v-data-table
          disable-pagination
          hide-default-footer
          :items="telemetryProviderData"
          :headers="tableFields"
          :loading="telemetryLoading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc">
          <template v-slot:item.last_vehicle_data="row">
            <if-set :value="row.item.last_vehicle_data">
              <multi-time-display :time="row.item.last_vehicle_data"/>
            </if-set>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'
import IfSet from '@/components/shared/IfSet'
import { map } from 'lodash'

export default {
  name: 'TelemetryProviderStatus',
  components: {
    MultiTimeDisplay,
    IfSet
  },
  mixins: [
    ApiUtilitiesMixin,
    CurrentUserMixin
  ],
  data () {
    return {
      telemetryProviderData: [],
      tableFields: [
        {
          value: 'customer.id',
          text: `${this.$tc('customer')} ${this.$tc('id')}`,
          sortable: true
        },
        {
          value: 'customer.name',
          text: this.$tc('customer'),
          sortable: true
        },
        {
          value: 'service_provider.name',
          text: this.$tc('service_provider'),
          sortable: true
        },
        {
          value: 'last_vehicle_data',
          text: this.$tc('last_vehicle_data_received'),
          sortable: true
        }
      ],
      telemetryLoading: true,
      autoRefreshEnabled: true,
      sortBy: 'last_vehicle_data',
      sortDesc: false
    }
  },
  mounted () {
    this.autoRefresh()
  },
  methods: {

    /**
     * Flips the autorefresh bit and refreshes the data or removes any existing
     * refresh job from the queue (depending of if the bit is true or false)
     *
     * @return undefined
     */
    toggleAutoRefresh () {
      // Flip the auto refresh bit
      this.autoRefreshEnabled = !this.autoRefreshEnabled

      // If we've disabled the auto refresh feature then clear the queued
      // execution of the refresh function
      if (!this.autoRefreshEnabled) {
        clearTimeout(this.autoFetchPid)
      } else {
        this.autoRefresh()
      }
    },

    /**
     * Retrieve the data from the API and queue a refresh if enabled
     * @return undefined
     */
    autoRefresh () {
      this.fetchData()

      if (this.autoRefreshEnabled) {
        this.autoFetchPid = setTimeout(this.autoRefresh, 20000)
      }
    },

    /**
     * Retrieve the data from the API
     * @return {Promise<void>}
     */
    async fetchData () {
      this.telemetryLoading = true

      try {
        const resp = await this.$orm('CustomerServiceProvider')
          .findAll({
            customer_id: map(this.customers, (c) => { return c.id }).join(','),
            expand: 'customer,service_provider',
            fields: 'id,customer.id,customer.name,service_provider.name,last_vehicle_data'
          })
        this.telemetryProviderData = resp.items
      } catch (error) {
        this.renderErrorModal(error)
      } finally {
        this.telemetryLoading = false
      }
    }
  },

  /**
   * When we browse away remove any queued autoRefresh() execution. This hook is
   * provided and executed by vue-router. Read more at
   * https://router.vuejs.org/guide/advanced/navigation-guards.html
   */
  beforeRouteLeave (to, from, next) {
    if (this.autoFetchPid) {
      clearTimeout(this.autoFetchPid)
    }
    next()
  }
}
</script>
